import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import React from 'react';

import { useDisplayUsdcAsUsd } from '@/hooks/useDisplayUsdcAsUsd';
import { LocaleContext, useTranslator } from '@/hooks/useTranslator';
import { CurrencyCodeType } from '@/types/currency';
import { Locale } from '@/types/locale';
import { formatAmount } from '@/utility/formatAmount';

interface Props {
  readonly balanceAmount: number;
  readonly currency: CurrencyCodeType;
  readonly available?: boolean;
}

export const CryptoAccountDetailsItem: React.FC<Props> = (props: Props): React.ReactElement => {
  const { balanceAmount, available = false, currency } = props;

  const locale = React.useContext<Locale>(LocaleContext);
  const tr = useTranslator();
  const displayUsdcAsUsd = useDisplayUsdcAsUsd();

  return (
    <Box display="flex" alignItems="center" justifyContent="space-between" width="100%">
      <Box>
        <Typography fontSize={16} lineHeight="24px" fontWeight={400}>
          {tr('CALIZA_ACCOUNT', currency)}
        </Typography>
        <Typography fontSize={16} lineHeight="24px" fontWeight={400} color="custom.LightGray">
          {tr('BALANCE')}:{' '}
          {formatAmount(locale, balanceAmount, currency, undefined, undefined, displayUsdcAsUsd)}
        </Typography>
      </Box>
      {!available ? (
        <Box>
          <Typography fontSize={14} fontWeight={400} lineHeight="20px" color="custom.LightGray">
            {tr('INSUFFICIENT_FUNDS')}
          </Typography>
        </Box>
      ) : (
        <></>
      )}
    </Box>
  );
};
